window.updateImageCount = function() {
  // 新規モード（分離UI）
  if (document.querySelector('.image-upload-primary')) {
    const primaryUpload = document.querySelector('.image-upload-primary .image-forms-primary');
    const primaryCashed = document.querySelector('#photos_cashed_wrapper_primary');
    const additionalUpload = document.querySelector('.image-upload-additional .image-forms-additional');
    const additionalCashed = document.querySelector('#photos_cashed_wrapper_additional');

    const primaryCount = (primaryUpload?.children.length || 0) + (primaryCashed?.children.length || 0);
    const additionalUploadCount = additionalUpload?.children.length || 0;
    const additionalCashedCount = additionalCashed?.children.length || 0;
    const additionalCount = additionalUploadCount + additionalCashedCount;

    // 1枚目カウンター: アップ済時のみ「1/1」を表示
    const primaryCounterEl = document.querySelector('.image-counter-primary');
    const primaryCountEl = document.querySelector('.image-count-primary');
    if (primaryCountEl) primaryCountEl.textContent = primaryCount;
    if (primaryCounterEl) primaryCounterEl.classList.toggle('hidden', primaryCount === 0);

    // 追加画像カウンター更新
    const additionalCountEl = document.querySelector('.image-count-additional');
    if (additionalCountEl) additionalCountEl.textContent = additionalCount;

    // 追加画像の最大値表示: 1枚目未アップ時は全体max(10)、アップ済時は追加max(9)
    const additionalMaxEl = document.querySelector('.image-max-additional');
    let additionalMax = null;
    if (additionalMaxEl) {
      const fullMax = Number(additionalMaxEl.dataset.fullMax);
      additionalMax = Number(additionalMaxEl.dataset.additionalMax);
      const effectiveMax = primaryCount === 0 ? fullMax : additionalMax;
      additionalMaxEl.textContent = effectiveMax;
    }

    // 追加画像が満杯になったらアップロード欄を非表示にする（primary の has-primary と同様の挙動）。
    // 非表示判定は Uppy 実上限 (additionalMax=9 固定) で行う。
    // カウンター表示の effectiveMax (10 or 9) と分離することで、
    // 「1枚目未アップ + 追加9枚」の状態ではカウンター 9/10 + 追加DragDrop非表示 + 1枚目DragDropのみ表示となり、
    // ユーザーに「残り1枠は1枚目スロット」であることを視覚的に示し、silent reject を防ぐ。
    const additionalSection = document.querySelector('.image-upload-additional');
    if (additionalSection && additionalMax !== null) {
      additionalSection.classList.toggle('has-additional-full', additionalCount >= additionalMax);
    }
    return;
  }

  // 編集モード（旧UI）
  if (!document.querySelector('.image_forms')) { return; }
  const additional_image_count = document.querySelector('.image_forms').children.length;
  const cashed_image_count = document.querySelector('#photos_cashed_wrapper') ? document.querySelector('#photos_cashed_wrapper').children.length : 0;
  document.querySelector('#image_count').textContent = additional_image_count + cashed_image_count;
};
